export const SELECT_BLOG_ITEM = "SELECT_BLOG_ITEM";
export const DESELECT_BLOG_ITEM = "DESELECT_BLOG_ITEM";
export const SET_BLOG_CATEGORY_FILTER = "SET_BLOG_CATEGORY_FILTER";
export const SET_BLOG_TAG_FILTER = "SET_BLOG_TAG_FILTER";
export const SET_BLOG_TIMELINE_FILTER = "SET_BLOG_TIMELINE_FILTER";
